import { HttpClient, HttpBackend } from '@angular/common/http';
import { environment } from '@env';
import { SessionStorageService } from 'ngx-webstorage';
import { AuthClientConfig, AuthConfig } from '@auth0/auth0-angular';
import { Domain } from '../models/domain';
import { firstValueFrom } from 'rxjs';

export function auth0Initializer(handler: HttpBackend, config: AuthClientConfig, sessionStorage: SessionStorageService) {
  return () =>
    firstValueFrom(new HttpClient(handler).get<Domain>(environment.serverBaseUrl + 'domain')).then((domain: any) => {
      sessionStorage.clear('use-universal-login');
      config.set({
        domain: '',
        clientId: ''
      });
      // mfa admiral
      const validOrigins = ['test-auth0-app.esendex.it'];
      // validOrigins.push('localhost');
      validOrigins.push('app2.esendex.it');
      validOrigins.push('messenger.smts.it');
      if (validOrigins.some(origin => window.location.origin.includes(origin))) {
        if (domain.clientId?.length && domain.customDomain?.length && domain.audience?.length) {
          domain.useUniversalLogin = true;
        }
      }

      if (domain.useUniversalLogin && domain.clientId?.length && domain.customDomain?.length) {
        // if (false) {
        sessionStorage.store('use-universal-login', true);
        const configAuth0: AuthConfig = {
          domain: domain.customDomain.replace(/\/$/, ''),
          clientId: domain.clientId,
          cacheLocation: 'localstorage',
          authorizationParams: {
            audience: domain.audience,
            redirect_uri: window.location.origin
          },
          errorPath: '/error',
          httpInterceptor: {
            allowedList: [
              // '/API/*',
              { uri: '/API/*', allowAnonymous: true }
            ]
          }
        };
        config.set(configAuth0);
      }
    });
}
